exports.components = {
  "component---src-pages-dealer-index-tsx": () => import("./../../../src/pages/dealer/index.tsx" /* webpackChunkName: "component---src-pages-dealer-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

